import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FoundMedicationIncident } from "app/shared/types";
import { PipeModule } from "app/shared/pipes";
import { FoundMedicationIncidentModel } from "../../services/found-medication-incident-model.service";

@Component({
	imports: [CommonModule, PipeModule],
	providers: [FoundMedicationIncidentModel],
	selector: "ic-medication-incident-list-item",
	templateUrl: "./medication-incident-list-item.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ["./medication-incident-list-item.component.scss"],
})
export class MedicationIncidentListItemComponent implements OnInit {
	private readonly router = inject(Router);
	private readonly foundMedicationIncidentModel = inject(FoundMedicationIncidentModel);

	// @ts-expect-error TS2564
	@Input() incident: FoundMedicationIncident;

	// @ts-expect-error TS2564
	protected locationDescription: string;

	ngOnInit() {
		this.locationDescription = this.getLocationDescription();
	}

	protected openSummary() {
		this.router.navigate(["found-medication-incident", this.incident.id, "summary"]);
	}

	private getLocationDescription() {
		const { location } = this.incident;

		const parts = [
			location.departmentId
				&& this.foundMedicationIncidentModel
					.departmentsOptions()
					.find((department) => department.value === location.departmentId)?.label,
			location.roomId,
			location.description,
		].filter(Boolean);

		return parts.join(" - ");
	}
}
